import { Outlet } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import { isStaff, useMe } from '../api/me';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

export default function Layout() {
  const { data: me, isLoading, isError } = useMe();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-ink/50">
        Cargando…
      </div>
    );
  }
  if (isError) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-red-700">
        No se pudo cargar tu perfil. Refresca la página.
      </div>
    );
  }
  if (!isStaff(me)) {
    // Un cliente final ha entrado al CRM: no es su sitio.
    return (
      <div className="min-h-screen flex items-center justify-center p-8">
        <div className="max-w-md rounded-2xl bg-surface border border-deep/10 px-6 py-8 text-center">
          <p className="text-xl font-bold text-deep">habitania</p>
          <p className="mt-3 text-sm text-ink/60">
            Esta área es del equipo de Habitania. Tu cuenta de cliente funciona
            en la web, en el apartado «Mi cuenta».
          </p>
          <button
            onClick={() => signOut()}
            className="mt-6 rounded-full bg-brand px-6 py-2.5 text-sm font-bold text-white hover:bg-deep transition"
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <TopBar me={me!} />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 px-5 py-6 sm:px-8 sm:py-8 max-w-6xl mx-auto w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
